var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("header-login"),
      _vm._v(" "),
      _c("main", { staticClass: "registerScreen" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row --mainRow" }, [
            _c("div", {
              staticClass:
                "col-xs-12 col-md-4 col-lg-4 col-xl-6 d-none d-xl-block --loginBg leftCol"
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-xs-12 col-md-12 col-lg-12 col-xl-6 rightCol"
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "paddingBox" }, [
                  _c("h2", [_vm._v("Registrácia")]),
                  _vm._v(" "),
                  _vm.responseText != ""
                    ? _c(
                        "div",
                        {
                          class: "alert alert-" + _vm.responseType,
                          attrs: { role: "alert" }
                        },
                        [
                          _c("span", { class: "icon --" + _vm.responseType }),
                          _vm._v(
                            _vm._s(_vm.responseText) +
                              " \n                            "
                          ),
                          _vm.responseType == "success"
                            ? _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    color: "#4CAF50",
                                    "text-decoration": "underline"
                                  },
                                  attrs: {
                                    to: {
                                      name: "login",
                                      params: { reset: true }
                                    }
                                  }
                                },
                                [_vm._v("Prihlásiť sa")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-lg-7 col-xl-7" }, [
                      _c(
                        "div",
                        {
                          staticClass: "nav nav-tabs",
                          attrs: { id: "nav-tab", role: "tablist" }
                        },
                        [
                          _c(
                            "a",
                            {
                              class: "nav-item nav-link show" + _vm.active0,
                              attrs: { id: "jednotlivec-tab", role: "tab" },
                              on: {
                                click: function($event) {
                                  return _vm.regType("jednotlivec")
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "icon --jednotlivec" }),
                              _vm._v(
                                "Jednotlivec\n                                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              class: "nav-item nav-link show" + _vm.active1,
                              attrs: { id: "kolektiv-tab", role: "tab" },
                              on: {
                                click: function($event) {
                                  return _vm.regType("kolektiv")
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "icon --kolektiv" }),
                              _vm._v(
                                "Kolektív\n                                    "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "tab-content",
                          attrs: { id: "nav-tabContent" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "tab-pane fade show active",
                              attrs: {
                                id: "jednotlivec",
                                role: "tabpanel",
                                "aria-labelledby": "jednotlivec-tab"
                              }
                            },
                            [
                              _c("form", { on: { submit: _vm.formSubmit } }, [
                                _c("div", { staticClass: "form-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-md-12" },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "meno-jednotlivec" } },
                                        [_vm._v("Meno *")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.meno,
                                            expression: "meno"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "text", required: "" },
                                        domProps: { value: _vm.meno },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.meno = $event.target.value
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-md-12" },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "email-jednotlivec" } },
                                        [_vm._v("E-mail *")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.email,
                                            expression: "email"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "email", required: "" },
                                        domProps: { value: _vm.email },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.email = $event.target.value
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-md-12" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: { for: "password-jednotlivec" }
                                        },
                                        [_vm._v("Heslo *")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.heslo,
                                            expression: "heslo"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "password",
                                          required: ""
                                        },
                                        domProps: { value: _vm.heslo },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.heslo = $event.target.value
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-md-12" },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "okres-jednotlivec" } },
                                        [_vm._v("Okres")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          staticClass: "custom-select",
                                          attrs: { type: "text" },
                                          on: {
                                            change: function($event) {
                                              return _vm.onChange(
                                                $event.target.value
                                              )
                                            }
                                          }
                                        },
                                        _vm._l(_vm.okresy, function(item) {
                                          return _c(
                                            "option",
                                            { domProps: { value: item.name } },
                                            [_vm._v(_vm._s(item.name))]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-row" }, [
                                  _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox mb-2"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.suhlas1,
                                              expression: "suhlas1"
                                            }
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            type: "checkbox",
                                            id: "customCheck1",
                                            required: ""
                                          },
                                          domProps: {
                                            checked: Array.isArray(_vm.suhlas1)
                                              ? _vm._i(_vm.suhlas1, null) > -1
                                              : _vm.suhlas1
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.suhlas1,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.suhlas1 = $$a.concat([
                                                      $$v
                                                    ]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.suhlas1 = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.suhlas1 = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm._m(1)
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox mb-2"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.suhlas2,
                                              expression: "suhlas2"
                                            }
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            type: "checkbox",
                                            id: "customCheck2",
                                            required: ""
                                          },
                                          domProps: {
                                            checked: Array.isArray(_vm.suhlas2)
                                              ? _vm._i(_vm.suhlas2, null) > -1
                                              : _vm.suhlas2
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.suhlas2,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.suhlas2 = $$a.concat([
                                                      $$v
                                                    ]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.suhlas2 = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.suhlas2 = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm._m(2)
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox mb-2"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.suhlas3,
                                              expression: "suhlas3"
                                            }
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            type: "checkbox",
                                            id: "customCheck3"
                                          },
                                          domProps: {
                                            checked: Array.isArray(_vm.suhlas3)
                                              ? _vm._i(_vm.suhlas3, null) > -1
                                              : _vm.suhlas3
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.suhlas3,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.suhlas3 = $$a.concat([
                                                      $$v
                                                    ]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.suhlas3 = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.suhlas3 = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm._m(3)
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Údaje označené hviezdičkou sú povinné."
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-md-12" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn --primary w-100",
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.$scrollToTop($event)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                        Registrovať sa "
                                          ),
                                          _c("span", { staticClass: "icon" })
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-row" }, [
                                _c("div", { staticClass: "col-12 col-md-12" }, [
                                  _vm.skupina == 0
                                    ? _c("span", [
                                        _vm._m(4),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn --primary w-100 --facebookNormal",
                                            on: { click: _vm.fbLogin }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                        Prihlásiť sa cez Facebook "
                                            ),
                                            _c("span", {
                                              staticClass:
                                                "icon d-none d-md-inline-block"
                                            })
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              ])
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(5)
                  ])
                ])
              ]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ol",
      { staticClass: "m-stepNavigation", attrs: { id: "scrollReg" } },
      [
        _c("li", { staticClass: "a-stepNavigation__item" }, [
          _vm._v("Registrácia")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "custom-control-label", attrs: { for: "customCheck1" } },
      [
        _vm._v(
          "Mám záujem o registráciu na stránke adoptujkravicku.sk a o účasť v súťaži, ktorej organizácia sa spravuje "
        ),
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://www.adoptujkravicku.sk/pravidla-pouzivania/"
            }
          },
          [_vm._v("Pravidlami súťaže")]
        ),
        _vm._v(".*")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "custom-control-label", attrs: { for: "customCheck2" } },
      [
        _vm._v(
          "Súhlasím so spracúvaním mojich osobných údajov za podmienok uvedených v "
        ),
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href:
                "https://www.adoptujkravicku.sk/pravidla-ochrany-osobnych-udajov/"
            }
          },
          [_vm._v("Pravidlách ochrany osobných údajov")]
        ),
        _vm._v(" spojených s prevádzkou webovej stránky adoptujkravičku.sk.*")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "custom-control-label", attrs: { for: "customCheck3" } },
      [
        _vm._v(
          "Súhlasím so zasielaním marketingových informácií o slovenskom mlieku a mliečnych výrobkoch rôznych slovenských výrobcov na môj e-mail za podmienok uvedených v "
        ),
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href:
                "https://www.adoptujkravicku.sk/pravidla-ochrany-osobnych-udajov/"
            }
          },
          [_vm._v("Pravidlách ochrany osobných údajov")]
        ),
        _vm._v(" spojených s prevádzkou webovej stránky adoptujkravičku.sk.")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-separator text-center" }, [
      _c("span", [_vm._v("alebo")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-5 col-xl-5" }, [
      _c("aside", { staticClass: "o-widget mb-md-5" }, [
        _c("div", { staticClass: "m-widgetContent" }, [
          _c("div", { staticClass: "m-widgetContent__description" }, [
            _c("p", [
              _vm._v(
                "Tu sa môžeš zaregistrovať a adoptovať si tak svoju kravičku."
              )
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("Benefity:")])
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "m-widgetContent__list" }, [
            _c("li", [
              _vm._v(
                "zaregistruj sa a môžeš si tú svoju kravičku vybrať a dať jej meno"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "zaregistruj sa a môžeš svoju kravičku prísť pozrieť na farmu"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("zaregistruj sa, súťaž a vyhraj pekné ceny")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }